<template>
  <div class="site-testimonial">
    <aside class="testimonial-area">
      <div class="testimonial-content">
        <div class="testimonial-review">
          <div class="slider-pro" id="example5">
            <div class="sp-slides">
              <div class="sp-slide" v-for="(item, index) in items.testimonial" :key="index">
                <p class="sp-padding" style="color:#00517e;" v-html="item.word"/>
                <div class="sp-thumnail-card">
                  <div class="sp-thumbnail-image">
                    <img class="thumbnail-image" :src="currentUrl+'/files/testimonial/'+item.photo">
                  </div>
                  <div class="sp-thumbnail-text">
                    <h5 v-text="item.name"/>
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="sp-thumbnails">
              <div class="sp-thumbnail" v-for="(item, index) in items.testimonial" :key="index">
                <div class="sp-thumnail-card">
                  <div class="sp-thumbnail-image">
                    <img class="thumbnail-image" :src="currentUrl+'/files/testimonial/'+item.photo">
                  </div>
                  <div class="sp-thumbnail-text">
                    <h5 v-text="item.name"/>
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="testimonial-right">
          <div class="testimonial-group">
            <div class="testimonial-title">
              <h5>สื่อและลูกค้าที่พูดถึงเรา</h5>
            </div>
            <div class="testimonial-description">
              <span>ติดต่อศูนย์บริการลูกค้า</span>
              <span>ติดต่อ Call Center ได้ตลอด 7 วัน 24 ชม.</span>
            </div>
            <button
              @click="showCallback()"
              class="btn btn--contact btn--square btn--full popup-callback"
            >{{ button_title }}</button>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      button_title: null
      //currentUrl: window.location.protocol + '//' + window.location.host + '/'
    };
  },
  props: {
    items: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl']),
    // ...mapState({ items: state => state.salepage })
  },
  methods: {
    showCallback() {
      // showCallback = $("#modal-callback")
      //   .mobiscroll()
      //   .popup({
      //     display: "center",
      //     buttons: [],
      //     layout: "liquid"
      //   })
      //   .mobiscroll("getInst");
      $("#callback").show(), !1;
    }
  },
  updated() {
    this.button_title = this.items.sale_page.button_title;
    $("#example5").sliderPro({
      width: 350,
      height: 200,
      orientation: "vertical",
      loop: false,
      arrows: false,
      buttons: false,
      thumbnailsPosition: "bottom",
      thumbnailPointer: true,
      thumbnailWidth: 170,
      thumbnailHeight: 87,
      autoplay: true,
      breakpoints: {
        500: {
          thumbnailsPosition: "bottom",
          thumbnailWidth: 160,
          thumbnailHeight: 87
        }
      }
    });
  }
};
</script>

<style>
</style>